module.exports = __webpack_public_path__ + "img/structures.72ba1dac.jpg";